import React from "react";
import { heroTranslation } from "data/home/translationHome";
import { useLanguagesContext } from "hooks/useContextAll";

const HomeView = () => {
    const language = useLanguagesContext();

    return (
        <div className="hero animate-fade-up">
            <p>
                <span
                    className="hero-text"
                    dangerouslySetInnerHTML={{
                        __html: heroTranslation[language.language],
                    }}
                ></span>
            </p>
        </div>
    );
};

export default HomeView;
